module.exports = __webpack_public_path__ + "assets/germany_3FdzB.svg";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/finance-components/src/images/flag/germany.svg
// module id = 815
// module chunks = 0